import {Pipe, PipeTransform} from "@angular/core";
import {DELIVERY_STATUSES} from "../_maps/delivery-statuses";

@Pipe({name: "deliveryStatus"})
export class DeliveryStatusPipe implements PipeTransform {
  transform(status: string): any {
    return DELIVERY_STATUSES[status];
  }
}
